import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import TableComponent, { StyledTableRow } from "../../components/Table/Table";
import { tableHeaders } from "./utils";
import { TableCell } from "@mui/material";

export default function TableBillingHistory({ data }: any) {
  const { t } = useTranslation();
  const headers = useMemo(() => tableHeaders(t), [t]);
  const sumDoctor = data.reduce((accumulator: any, object: any) => {
    return accumulator + object.totalDoctorValue;
  }, 0);
  return (
    <TableComponent headerCfg={headers}>
      {/* The rows are the week buckets built by groupByWeekAndSum, which have
          no id — `row.id` was undefined and React warned about the missing
          key. The grouping dedupes by startDate, so it is unique. */}
      {(data as any).map((row: any) => (
        <StyledTableRow key={row.startDate}>
          <TableCell align="center">
            {row.startDate} - {row.endDate}
          </TableCell>
          <TableCell align="center">
            {new Intl.NumberFormat("pt-PT", {
              style: "currency",
              currency: "EUR"
            }).format(row.totalDoctorValue)}
          </TableCell>
        </StyledTableRow>
      ))}
      <StyledTableRow>
        <TableCell align="center">
          <b>{t("common.total")}</b>
        </TableCell>
        <TableCell align="center">
          <b>
            {new Intl.NumberFormat("pt-PT", {
              style: "currency",
              currency: "EUR"
            }).format(sumDoctor)}
          </b>
        </TableCell>
      </StyledTableRow>
    </TableComponent>
  );
}
